import DOMPurify from 'dompurify';

/**
 * Sanitiza um ícone SVG guardado no banco, para renderizar com `v-html`.
 *
 * ---------------------------------------------------------------------------
 * POR QUE ISTO NÃO É O `sanitizeRichText`
 * ---------------------------------------------------------------------------
 * A allowlist de texto rico não tem `svg` nem nenhuma das ~60 tags do formato,
 * então passar um ícone por ela devolve string vazia — o ícone some da tela.
 * São dois formatos com dois vocabulários; um sanitizador só para os dois ou
 * deixa passar demais no texto, ou come o ícone.
 *
 * ---------------------------------------------------------------------------
 * SVG É EXECUTÁVEL — É POR ISSO QUE PRECISA PASSAR POR AQUI
 * ---------------------------------------------------------------------------
 * SVG não é imagem inerte quando embutido no documento: aceita `<script>`,
 * `onload`, `<foreignObject>` com HTML dentro e `href` apontando para
 * `javascript:`. Um ícone é conteúdo que um administrador cola num formulário e
 * que depois aparece na tela de todo mundo — a definição de XSS armazenado.
 *
 * O perfil `svg` do DOMPurify cobre exatamente esse vocabulário e remove o
 * resto. `svgFilters` entra junto porque os ícones da casa usam `<filter>` para
 * sombra; sem ele o ícone renderiza sem o efeito.
 *
 * TESTE: veja a nota em `sanitizeRichText.ts` sobre `@vitest-environment jsdom`.
 * O environment padrão do vitest (happy-dom) não sanitiza, e um teste escrito
 * nele não mede nada.
 */
export function sanitizeSvgIcon(svg?: string | null): string {
  return DOMPurify.sanitize(String(svg ?? ''), {
    USE_PROFILES: { svg: true, svgFilters: true },
  });
}
